<template>
  <div class="app-search-wrapper">
    <div class="app-search-term">
      <ul class="app-tags">
        <li v-for="tag in filterTags" v-bind:key="tag.type">
          <span class="app-by">
              <div class="status-overlay">
              {{tag.displayKey}}
            </div>
              {{tag.displayValue}}</span>
          <span @click="removeTags(tag)" class="status-overlay-close">
              <svgicon name="cancelblack" width="8" height="8" :original="true"/>
            </span>
        </li>
      </ul>
    </div>
    <div class="app-search-term">
      <ul class="app-tags" v-if="filterTerms.length">
        <li v-for="(term,index) in filterTerms" :key="`term-${index}`">
          <span class="curr-filter">
            <div class="status-overlay">
            {{term.tlabel ? $t(term.tlabel) : term.label}}
          </div></span>
          <input v-if="!term.field_type"
                 placeholder="Enter search term"
                 type="text"
                 :name="`search-term-${index}`"
                 v-model="term.query"
                 @input="searchTerm($event,term)">

          <DatePicker
            v-if="term.field_type === 'date'"
            v-model="term.query"
            @change="dateSelectTerm(term)"
            type="date"
            :clearable="false"
            size="small"
          />
          <span class="status-overlay-close" @click="removeSearchTerm(term)">
            <svgicon name="cancelblack" width="8" height="8" :original="true"/>
          </span>
        </li>
      </ul>
    </div>
    <div class="app-search-tags">
      <Popover v-model="visible" placement="bottom-right">
        <div class="app-search-field">
          <div class="tag-status" v-if="!multiFilter">
            <div class="title" v-if="filterList.length">{{filterTitle}}</div>
            <ul v-if="filterList.length">
              <li @click="statusChange(status)" v-for="status in filterList" v-bind:key="status.id">
                {{status.tlabel ? $t(status.tlabel) : status.name}}
              </li>
            </ul>
            <div v-if="subFilterList.length" class="title">{{subFilterTitle}}</div>
            <ul v-if="subFilterList.length">
              <li v-for="(type, index) in subFilterList"
                  :key="`type-${index}`"
                  @click="filterChange(type)" >
                {{type.tlabel ? $t(type.tlabel) : type.name}}
              </li>
            </ul>
          </div>
          <span v-else>
            <div class="tag-status" v-for="(filter,index) in filterList" :key="index">
              <div class="title">{{$t('MDM_FILTER_BY')}} {{filter.tlabel ? $t(filter.tlabel) : filter.title}}</div>
              <ul>
                <li @click="multiFilterChange(data, filter.id)" v-for="data in filter.values" v-bind:key="data.id">
                  {{data.tlabel ? $t(data.tlabel) : data.name}}
                </li>
              </ul>
            </div>
          </span>
          <div class="tag-filter" v-if="searchBy.length">
            <div class="title">{{$t('MDM_SEARCH_BY')}}</div>
            <ul class=“tag-search”>
              <li @click="updateFilterTerm(term)"
                  v-for="term in searchBy"
                  v-bind:key="term.id">
                {{term.tlabel ? $t(term.tlabel) : term.label}}
              </li>
            </ul>
          <!-- <button v-if="!hideExportAll" @click="$emit('exportAllInvoice')" class="btn btn-primary">
                  All Invoice Export
          </button> -->
          </div>
        </div>
        <div slot="reference">
          <div class="app-popover-wrapper" v-if="showFilter">
            <div v-if="visible" class="search-trigger">
              <svgicon name="cancelblack"
                       width="18"
                       height="18"
                       @click="visible=false"
                       :original="true" />
            </div>
            <span v-else class="search-trigger" @click="$emit('setFilterGA');visible=true">
                  <svgicon name="filter" width="18" height="18" :original="true" />
                </span>
          </div>
        </div>
      </Popover>
    </div>

    <div class="app-search-calender calenderstyle" v-if="hideDatePicker">
      <span class="datepicker-trigger" id="datepicker-trigger">
             <span @click="onClickDatePicker()" >
              <svgicon name="calendar" width="20" height="20" :original="true" />
            </span>
      </span>

      <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger'"
        :trigger="showDatePicker"
        mode="range"
        @date-one-selected="val => { dateOne = val }"
        @date-two-selected="val => { dateTwo = val }"
        @closed="showDatePicker=false; applyDates()"
      />

    </div>
    <!-- <div class="app-search-depot">
        <svgicon name="Depot-select" width="18" height="18" :original="true" />
      </div> -->
  </div>

</template>

<script>
import debounce from 'debounce';
import { findIndex } from 'lodash';

export default {
  props: {
    filterList: {
      type: Array,
      default: () => ([]),
    },
    subFilterList: {
      type: Array,
      default: () => ([]),
    },
    searchBy: {
      type: Array,
      default: () => ([]),
    },
    subFilterTitle: {
      type: String,
      default: '',
    },
    filterTitle: {
      type: String,
      default: 'Filter By Status',
    },
    selectedStatus: {
      type: Number,
    },
    selectedSearchBy: {
      type: Object,
      default: () => ({}),
    },
    selectedSubFilter: {
      type: Object,
      default: () => ({}),
    },
    hideDatePicker: {
      type: Boolean,
      default: false,
    },
    hideExportAll: {
      type: Boolean,
      default: false,
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
    multiFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterTags: [],
      filterTerms: [],
      showTagSearch: false,
      visible: false,
      queryTerm: null,
      showDatePicker: false,
      dateOne: null,
      dateTwo: null,
      clearSearchFilter: {
        lr_number: 'indent_id',
        indent_id: 'lr_number',
      },
    };
  },
  watch: {
    selectedStatus() {
      this.defaultFilterStatus();
      this.defaultSearchTerm();
    },
  },
  created() {
    this.defaultFilterStatus();
    this.defaultType();
    this.defaultSearchTerm();
    this.defaultValues();
  },
  methods: {
    defaultValues() {
      this.searchBy.forEach((filterParam) => {
        if (filterParam.query) {
          this.updateFilterTerm(filterParam);
        }
      });
      this.filterList.forEach((filterParam) => {
        if (filterParam.query) {
          const data = filterParam.values.find(val => val.id === filterParam.query);
          this.constructFilter(data, filterParam.id);
        }
      });
    },
    defaultFilterStatus() {
      const fetchStatus = this.filterList.find(access => access.id === this.selectedStatus);
      if (fetchStatus) {
        this.constructFilter(fetchStatus);
      }
    },
    onClickDatePicker() {
      this.showDatePicker = true;
    },
    applyDates() {
      if (this.dateOne && this.dateTwo) {
        const range = `${this.dateOne}:${this.dateTwo}`;
        this.updateFilter({
          displayKey: 'Date',
          displayValue: `${this.dateConversion(this.dateOne)} - ${this.dateConversion(this.dateTwo)}`,
          key: 'date',
          value: range,
        });
        this.$emit('dateChange', range);
      }
    },
    dateConversion(date) {
      return this.$moment(date).format('DD MMM YY');
    },
    defaultType() {
      const column = this.extractKey(this.selectedSubFilter);
      const fetchType = this.subFilterList.find(
        access => access.type === column && access.id === this.selectedSubFilter[column],
      );
      if (fetchType) {
        this.constructFilter(fetchType, 'type');
      }
    },
    defaultSearchTerm() {
      if (this.selectedSearchBy) {
        this.filterTerms = [];
        const dataKeys = Object.keys(this.selectedSearchBy);
        dataKeys.forEach((key) => {
          const fetchTerm = this.searchBy.find(access => access.id === key);
          if (fetchTerm) {
            fetchTerm.query = this.selectedSearchBy[key];
            this.updateFilterTerm(fetchTerm);
          }
        });
      }
    },
    extractKey(myObject) {
      const dataKeys = Object.keys(myObject);
      return dataKeys[0] ? dataKeys[0] : '';
    },
    updateFilter(term) {
      const idx = findIndex(this.filterTags, tag => tag.key === term.key);
      if (idx !== -1) {
        this.filterTags.splice(idx, 1);
      }
      this.filterTags.push(term);
    },
    updateFilterTerm(term) {
      this.visible = false;
      if (this.clearSearchFilter[term.id]) {
        this.removeSearchTerm({ id: this.clearSearchFilter[term.id] });
      }
      if (this.filterTerms.length > 1 || ((this.filterTags.length + this.filterTerms.length) > 2 && this.multiFilter)) {
        return;
      }
      const idx = findIndex(this.filterTerms, tag => tag.id === term.id);
      if (idx !== -1) {
        this.filterTerms.splice(idx, 1);
      }
      this.filterTerms.push(term);
    },
    removeTags(rmTag) {
      const idx = findIndex(this.filterTags, tag => tag.key === rmTag.key);
      if (idx !== -1) {
        this.filterTags.splice(idx, 1);
        if (this.multiFilter) {
          this.$emit('subFilterChange', { id: null, type: rmTag.key });
        } else if (rmTag.key === 'status') {
          this.$emit('filterChange', null);
        } else if (rmTag.key === 'type' || rmTag.key === 'movement') { // TODO Need to change
          this.$emit('subFilterChange', { id: null, type: rmTag.key });
        } else {
          this.$emit('dateChange', null);
        }
      }
    },
    removeSearchTerm(term) {
      const idx = findIndex(this.filterTerms, tag => tag.id === term.id);
      if (idx !== -1) {
        this.filterTerms[idx].query = null;
        this.filterTerms.splice(idx, 1);
        this.$emit('searchTermChange', { query: null, column: term.id });
      }
    },
    constructFilter(data, type = 'status') {
      this.updateFilter({
        displayKey: type,
        displayValue: data.name,
        key: type,
        value: data.id,
      });
    },
    statusChange(status) {
      this.constructFilter(status);
      this.visible = false;
      this.$emit('filterChange', status.id);
    },
    filterChange(data) {
      const textKey = data.type || 'type';
      this.constructFilter(data, textKey);
      this.visible = false;
      this.$emit('subFilterChange', data);
    },
    multiFilterChange(data, type) {
      this.visible = false;
      const textKey = type;
      if (!((this.filterTags.length + this.filterTerms.length) > 2 && this.multiFilter)) {
        this.constructFilter(data, textKey);
        this.$emit('subFilterChange', data, textKey);
      }
    },
    searchTerm: debounce(function debounceSearch($event, term) {
      this.$nextTick(() => {
        let query = $event.target.value;
        query = (query) || null;
        this.$emit('searchTermChange', { query, column: term.id });
      });
    }, 600),
    dateSelectTerm(term) {
      this.$emit('searchTermChange', { query: term.query, column: term.id });
    },
  },
};
</script>
<style lang="scss">
</style>
